<template>
    <div class="container-base" v-once>
        <div class="pages page-static">
            <h1 style="font-size: 140%;">yagiprime利用規約</h1>
            <div class="page-static-inner">
                <h2 style="padding-top: 15px; margin-bottom: 10px;">第1条（規約の適用）</h2>
                <p>
                    「yagiprime（ヤギプライム）利用規約」（以下、「本規約」といいます）は、株式会社Yagish（以下、「当社」といいます。）が提供する「yagiprime」サービス（以下「本サービス」といい、第2条で定義されます。）の利用者（以下、「サービス利用者」といいます。）が本サービスを利用するにあたり行う一切の行為に適用されるものとし、サービス利用者は本規約に同意の上、本サービスを利用するものとします。
                </p>
                <h2 style="padding-top: 15px; margin-bottom: 10px;">第2条（サービスの内容）</h2>
                <p>本サービスは、以下の機能から構成された、当社が提供するサービスのことをいいます。</p>
                <ol style="list-style-type: decimal;">
                    <li>当社が提供する以下のサービスの利用
                        <ul>
                            <li>① yagish</li>
                            <li>② ヤギオファー</li>
                            <li>③ ヤギの宅配便</li>
                            <li>④ ヤギのメール便</li>
                            <li>⑤ ヤギのフォントサービス</li>
                        </ul>
                    </li>
                    <li>当社が、当社の審査を経て本サービスに利用登録されている人材紹介事業者から、担当エージェント（以下、「エージェント」といいます。）の紹介を受けるサービス</li>
                    <li>サービス利用者が必要な情報を入力することにより、AIにより自動的に履歴書の自己PR等を作成するサービス</li>
                </ol>
                <h2 style="padding-top: 15px; margin-bottom: 10px;">第3条（サービスの利用）</h2>
                <ol style="list-style-type: decimal;">
                    <li>本サービスをご利用になる場合、サービス利用者は、本規約ならびに第2条（1）に掲げる当社のサービスの各利用規約に同意する必要があります。
                        <ul style="list-style-type: disc;">
                            <li>yagish・ヤギの宅配便・ヤギのメール便・ヤギのフォントサービス<a href="https://rirekisho.yagish.jp/terms">利用規約</a>
                            </li>
                            <li>ヤギオファー<a href="https://rirekisho.yagish.jp/yagiofferterms">利用規約</a></li>
                        </ul>
                    </li>
                    <li>サービス利用者はインターネットに接続の上、本サービスが提供されるウェブページにアクセスしていただく必要があります。本サービスを利用するためには、以下の環境が必要です。
                        <ul style="list-style-type: disc;">
                            <li>日本語が利用可能であること</li>
                            <li>CookieとJavaScriptの利用が可能であること</li>
                            <li>その他当社の指定する環境であること</li>
                        </ul>
                    </li>
                    <li>サービス利用者は自らの責任と費用において、本サービスへアクセス可能な機器、ソフト、環境を準備した上で本サービスを利用するものとします。サービス利用者は、当社によって提供されているインターフェイス以外の手段を用いて本サービスにアクセスしてはならないものとします。
                    </li>
                    <li>サービス利用者は、自らの意思によってのみ本サービスを利用し、利用にかかわる全ての責任を負うものとします。</li>
                    <li>サービス利用者は、本サービスの利用において、故意または過失による行為により、第三者に対して損害を生じさせた場合、自らの責任において解決し、当社は何らの責任を負わないこととします。</li>
                    <li>当社は、本サービスにおいて掲載される、提携企業の情報の内容の正確性、合法性、有効性およびその他一切に関する事由について、監視、審査などの管理に関する一切の責任を負わないものとします。</li>
                    <li>提携企業への登録内容および提携企業から情報の提供を受けて本サービスに掲載される情報に対するお問い合わせは、情報提供元の提携企業に直接ご連絡ください。</li>
                </ol>
                <h2 style="padding-top: 15px; margin-bottom: 10px;">第4条（利用契約の締結）</h2>
                <ol style="list-style-type: decimal;">
                    <li>本サービスの利用契約は、利用を希望する者（以下、「利用希望者」といいます。）が本利用規約ならびに第2条（１）に掲げる当社サービスの各利用規約の内容に同意して登録の申込みをし、かつ、当社がこの申込みに対して承諾することによって締結されます。なお、当社が申込みを承諾した日を利用契約の成立日（以下、「利用登録日」といいます。）とみなします。
                    </li>
                    <li>利用希望者は、本規約を遵守することに同意し、かつ、当社の定める一定の情報を当社の定める方法で当社に提供することにより、本サービスの利用登録を申請するものとします。</li>
                    <li>前項の申請は、利用希望者自身が行うものとし、真実、正確かつ最新の情報を当社に提供するものとします。</li>
                    <li>当社は、本条第1項に基づきサービス利用登録を申請した利用希望者が、以下の各号のいずれかの事由に該当する場合は、当該利用希望者のサービス利用登録を事前ないし事後に拒否することができるものとします。
                        <ol>
                            <li>① 本規約に違反するおそれ又は明確な違反があると当社が判断した場合</li>
                            <li>② 当社に提供された登録情報の全部又は一部につき虚偽、重要な誤記、記載漏れがある場合</li>
                            <li>③ 過去に本サービスのサービス利用登録取消処分を受けたことがある場合</li>
                            <li>④ その他当社がサービス利用登録を適当でないと判断した場合</li>
                        </ol>
                    </li>
                    <li>利用希望者は、当社が本サービスを提供するのに必要な範囲において利用希望者が本サービス上で登録した情報（以下「登録情報」といいます）を取得し利用することに同意します。</li>
                    <li>本サービスでは、サービス利用者の利便性の向上のために、Googleアカウント、その他第三者が運営するサービス（以下、「外部サービス」といいます。）のアカウントによりサービス利用登録、ログインする機能を提供します。利用希望者が外部サービスのアカウントによりサービス利用登録、ログインする場合、当社が、外部サービスに登録された利用希望者に関する情報を取得する場合があることを利用希望者は承諾するものとします。なお、外部サービスに提供した情報については、外部サービスの利用規約・プライバシーポリシーに従って取り扱われますが、当社が取得した情報については、当社の利用規約・プライバシーポリシーに従って取り扱われます。
                    </li>
                </ol>
                <h2 style="padding-top: 15px; margin-bottom: 10px;">第5条（yagiprime利用規約の範囲）</h2>
                <ul style="list-style-type: decimal;">
                    <li>本規約に定めのない事項については、当社が別途制定し当社ウェブページに記載する<a
                            href="https://rirekisho.yagish.jp/terms">yagish(ヤギッシュ)利用規約</a>の定めに従うものとします。</li>
                    <li>本規約以外に、当社が別途次の各号の事項（以下、「yagiprime利用に関する告知事項」といいます。）を定めた場合には、これらも本規約と同等の効力を有し、本サービスの利用に関し、適用されるものとします。
                        <ol>
                            <li>① 「ご利用上の注意」、「ご案内」等、名称の如何を問わず、本サービスの利用方法に関して本サービスのウェブサイト上で告知される利用上の注意事項</li>
                            <li>② 前号の他、会員の資格、権利、yagiprimeの利用、その他必要事項に関し、yagish（ヤギッシュ）のウェブサイト上の表示として随時なされる通知</li>
                        </ol>
                    </li>
                    <li>前項のyagiprime利用に関する告知事項は、特に適用開始時期を定めない限り、当社が当該告知事項をサイト上に表示したときをもって効力を生じ、同時にサービス利用者の承諾があったものとみなします。（以下、単に本規約という場合には、yagiprime利用に関する告知事項を含むものとします。）
                    </li>
                </ul>
                <h2 style="padding-top: 15px; margin-bottom: 10px;">第6条（サービスの中断・中止等）</h2>
                <ol style="list-style-type: decimal;">
                    <li>当社は、当社が必要と判断する場合、また運営上、技術上の必要に応じて、本サービスの一部または全部を中断、中止、停止、廃止、変更することができます。</li>
                    <li>前項の場合、当社の責めによらない事項によってサービス利用者に生じた損害について、当社は一切の責任を負いません。</li>
                    <li>本条第1項の場合、当社は、本サービス提供画面上又は当社が運営するウェブサイトに掲示する方法等にて、管理者に通知するものとし、これをもってサービス利用者への通知を完了したものとします。ただし、当社が事前に通知できない止むを得ない理由がある場合には、事後に通知するものとします。
                    </li>
                </ol>
                <h2 style="padding-top: 15px; margin-bottom: 10px;">第7条（利用料および支払い等）</h2>
                <ul style="list-style-type: decimal;">
                    <li>サービス利用者は本サービス利用の対価として、本サービスの登録時に指定又は利用契約で定めた方法で、当社のウェブサイト又は利用契約で定めた利用料金を当社に支払うものとします。本サービス利用登録申し込みのための最終確認画面をよくご確認のうえお申し込みください。
                    </li>
                    <li>サービス利用者は、本サービスの利用料金を、利用登録期間の開始日に当社が指定する方法により支払うものとします。</li>
                    <li>サービス利用者は、当社が請求する費用に消費税その他法令で定めている税金を加算して支払うものとします。支払いの際に必要な振込手数料、送金手数料その他の費用については、サービス利用者が負担するものとします。
                    </li>
                    <li>利用料金は、利用契約に従って、サービス利用者が本サービスを利用できる初日から契約期間の末日まで発生します。その間、サービス利用者又はユーザーの実使用の有無は問いません。</li>
                    <li>サービス利用者から当社に対し、契約期間満了日までに、第8条第1項に定める利用契約を解約する旨の申し入れがなされない限り、契約期間満了日の翌日から30日間利用契約が自動更新されます。</li>
                    <li>サービス利用者が、利用料又は他の債務について、支払期日を経過しても支払いをしない場合、支払期日の翌日から年１４．６％の割合で計算して得た金額を遅延利息として当社に支払わなければなりません。
                    </li>
                </ul>
                <h2 style="padding-top: 15px; margin-bottom: 10px;">第8条（契約解約・解除）</h2>
                <ol style="list-style-type: decimal;">
                    <li>サービス利用者は、当社の定める方法で、いつでも当社に対し、利用契約を解約する旨の申入れをすることができます。この場合、当社は、法令等の定めに従ってこれを遅滞なく処理しなければなりません。
                    </li>
                    <li>サービス利用者が月額契約を利用する場合、当社は、サービス利用者の未精算金、遅延利息金及び当該月の利用料金を請求し、サービス利用者はこの支払いを完了しなければ契約解約ができないものとします。
                    </li>
                    <li>当社は、次の各号のいずれかに当たる場合、何らの催告なく、直ちに利用契約を解除することができます。
                        <ol>
                            <li>① 請求料金の決済期日において、サービス利用者が決済を行わない場合</li>
                            <li>② サービス利用者が本規約に違反した場合</li>
                            <li>③ サービス利用者による登録内容に虚偽事項があったことが判明した場合</li>
                            <li>④ その他、サービス利用者が本サービスを利用するのにふさわしくないと当社が判断した場合</li>
                        </ol>
                    </li>
                    <li>サービス利用者の責に帰すべき事由により利用契約が解除された場合、サービス利用者は期限の利益を喪失し、直ちに当社に対して全ての債務を支払わなければなりません。</li>
                    <li>当社は、本条に基づき当社が行った行為によりサービス利用者又はユーザーに生じた損害について一切の責任を負わないものとします。</li>
                </ol>
                <h2 style="padding-top: 15px; margin-bottom: 10px;">第9条（反社会的勢力の排除）</h2>
                <ol style="list-style-type: decimal;">
                    <li>当社及びサービス利用者は、相手方に対し、利用契約締結時において自己（当事者が法人の場合は、代表者、役員又は実質的経営支配者を含みます。）が暴力団、暴力団員、暴力団関係企業、総会屋、社会運動標榜ゴロ、特殊知能暴力集団等の反社会的勢力その他これらに準ずる者又はこれらと密接な関わりを有する者（以下、「反社会的勢力）といいます。）に該当しないこと、自己又は第三者のために反社会的勢力を利用しないこと、反社会的勢力に資金や便宜を提供しないことを表明し、かつ将来も該当しないことを保証します。
                    </li>
                    <li>当社は、サービス利用者が反社会的勢力に属すると判明した場合その他前２項の規定に違反する又は違反するおそれがあると判断する場合、何らの催告を要せず、利用契約を解除することができます。</li>
                    <li>当社が、前項の規定により利用契約を解除した場合、これに関連してサービス利用者に発生する損害について、当社は一切の責任を負わないものとします。</li>
                </ol>
                <h2 style="padding-top: 15px; margin-bottom: 10px;">第10条（規約およびサービス内容の変更）</h2>
                <ol style="list-style-type: decimal;">
                    <li>当社は、必要に応じ、本利用規約およびサービス内容の変更を随時行うことがあります。この場合、本サービスの提供条件などについては、変更後の利用規約が適用されるものとします。</li>
                    <li>前項において本利用規約を変更する場合、当社は、本サービス提供画面上又は当社が運営するウェブサイトに掲示する方法等にて、サービス利用者に通知するものとし、これをもってサービス利用者への通知を完了したものとします。
                    </li>
                    <li>当社が前項に従って通知を完了した日からサービス利用者の利用期間満了日までに、サービス利用者が異議の申し立てをしない場合、又は利用契約の解除の手続きをとらない場合、サービス利用者は変更後の新利用規約を承諾したものとみなします。
                    </li>
                </ol>
                <h2 style="padding-top: 15px; margin-bottom: 10px;">第11条（秘密保持及びサービス利用者の情報の保護）</h2>
                <ul style="list-style-type: decimal;">
                    <li>当社は、当社の審査を経て当社と契約した人材紹介事業会社及びその人材紹介事業会社が業務提携契約を締結しているエージェントに対し、サービス利用者への担当エージェント（以下、「エージェント」といいます。）の紹介を目的として、サービス利用者から提供された登録情報（個人情報を含む）の全部または一部を開示することができるものとします。
                    </li>
                    <li>前項にかかわらず、サービス利用者は、本サービス提供画面において、前項の情報開示を拒否することができます。
                    </li>
                    <li>当社は、サービス利用者の情報をこの規約で定める場合のほか、別途定めるプライバシーポリシー（<a
                            href="https://www.yagish.jp/privacy_policy/">https://www.yagish.jp/privacy_policy/</a>）に基づき、適切に取扱うものとします。サービス利用者は、本サービスを利用するにあたっては、本規約とともに、プライバシーポリシーにも同意をするものとします。なお、次の各号に定める事項については、サービス利用者は当社によるサービス利用者の情報の利用及び提供にあらかじめ同意します。
                        <ul>
                            <li>(1) 本サービスを提供するため</li>
                            <li>(2) 本サービスに付随するサービス提供のため</li>
                            <li>(3) メールマガジン、メール広告の送付のため</li>
                            <li>(4) アンケートや市場調査のため</li>
                            <li>(5) 入退会手続き、お問い合わせへの回答のため</li>
                        </ul>
                    </li>
                </ul>
                <h2 style="padding-top: 15px; margin-bottom: 10px;">第12条（紛争処理及び損害賠償）</h2>
                <ul style="list-style: decimal;">
                    <li>サービス利用者又はユーザは、本規約に違反又は本サービスの利用に関連して当社に損害を与えた場合、当社に対し、その損害を賠償するものとします。</li>
                    <li>サービス利用者は、本サービスを自己責任により利用するものとし、本サービスへの登録、利用から生じる一切の損害については、速やかに自己の責任と負担によりこれを解決します。</li>
                    <li>当社の故意又は重大な過失により、サービス利用者に損害が発生した場合は、前項の限りではないものとし、この場合に当社が支払うべき損害賠償の額は、損害が発生した日の直前にサービス利用者が当社に支払った利用料の額を上限とします。但し、本規約に別段の定めが規定されている場合は、当該規定が優先適用されるものとします。
                    </li>
                </ul>

                <p class="text-right">2024年7月1日制定</p>
                <div class="back-button"><a href="/" class="router-link-active">トップに戻る</a></div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<script>
export default {
    data: function () {
        return {}
    },
    computed: {},
    methods: {},
    watch: {},
    mounted: function () { }
}
</script>
